"use client";

import { TrendingUp } from "lucide-react";
import { StaggerContainer, StaggerItem } from "@/components/ui/animated-section";

interface ResultItem {
 label: string;
 value: string;
}

interface ResultsGridProps {
 title?: string;
 results: ResultItem[];
}

export function ResultsGrid({ title = "Key Results", results }: ResultsGridProps) {
 if (results.length === 0) return null;

 return (
 <section className="py-12">
 <h2 className="text-2xl font-bold text-foreground mb-6">{title}</h2>
 <StaggerContainer className="grid md:grid-cols-3 gap-4" staggerDelay={0.1}>
 {results.map((result, i) => (
 <StaggerItem key={i}>
  <div className="relative overflow-hidden bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-950/40 dark:to-teal-950/30 rounded-2xl p-6 text-center border border-emerald-200/60 dark:border-emerald-800/40 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group">
  {/* Decorative icon */}
  <div className="absolute top-3 right-3 opacity-10 group-hover:opacity-20 transition-opacity">
   <TrendingUp className="w-8 h-8 text-emerald-600" />
  </div>
  <p className="text-3xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">{result.value}</p>
  <p className="text-sm text-emerald-700 dark:text-emerald-300 mt-2 font-medium">{result.label}</p>
  </div>
 </StaggerItem>
 ))}
 </StaggerContainer>
 </section>
 );
}
